<template>
  <div class="flex-grow-1 d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="orders/ingredients"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :filtersValue="filtersValue"
      :date="date"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h2 class="page-heading mr-auto">На ингредиенты</h2>
        <btn-filters
          :data="data"
          endpoint="users"
          v-model="filtersValue"
          :range="true"
          :date.sync="date"
        ></btn-filters>
        <router-link
          class="btn btn-primary ml-2"
          to="/orders/ingredients/create"
        >Добавить заявку</router-link>
      </div>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @load-more="$refs.data.loadMore"
        @row-click="((row) => this.$router.push(`/orders/ingredients/${row.id}`))"
      >
        <el-table-column prop="" label="ФИО">
          <template slot-scope="{row}">
            {{row.user | fullName}}
          </template>
        </el-table-column>
        <el-table-column prop="id" label="№ заявки"/>
        <table-column-date label="Дата создания"/>
        <el-table-column prop="status.description" label="Статус заявки"/>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  export default {
    metaInfo: {title: 'Заявки на ингредиенты'},
    data () {
      return {
        data: {},
        loading: false,
        hasMore: true,
        filtersValue: null,
        date: {
          min: null,
          max: null,
        },
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/orders/ingredients/index.vue